export enum AUDIT_RECORD_TYPE {
    OBJECTIVE_ADDED                                                  = 'EntityAddedAudit',
    OBJECTIVE_CHANGED                                                = 'EntityUpdateAudit',
    OBJECTIVE_REMOVED                                                = 'EntityDeleteAudit',

    PROJECT_OBJECTIVE_PINSTATE_CHANGED                               = 'ProjectSubObjectivePinStateChangedAudit',
    PROJECT_OBJECTIVE_TIMING_OVERRIDE                                = 'ProjectSubObjectiveTimingOverrideChangedAudit',
    PROJECT_OBJECTIVE_NOTE_CHANGED                                   = 'ProjectSubObjectiveNotesChangedAudit',

    PROJECT_ACTIVITY_STATUS_CHANGED                                  = 'ProjectActivityCompletionStateChanged',
    PROJECT_ACTIVITY_COST_OVERRIDE_INFO_CHANGED                      = 'ProjectActivityCostOverridesChangedAudit',
    PROJECT_ACTIVITY_OPERATIONAL_COST_OVERRIDE_CHANGED               = 'ProjectActivityCostOverridesChangedAudit',
    PROJECT_ACTIVITY_OPERATIONAL_COST_OVERRIDE_NOTE_CHANGED          = 'ProjectActivityCostOverridesChangedAudit',
    PROJECT_ACTIVITY_ONGOING_COST_OVERRIDE_CHANGED                   = 'ProjectActivityCostOverridesChangedAudit',
    PROJECT_ACTIVITY_ONGOING_COST_OVERRIDE_NOTE_CHANGED              = 'ProjectActivityCostOverridesChangedAudit',
    PROJECT_ACTIVITY_START_END_OVERRIDE_CHANGED                      = 'ProjectActivityStartEndOverrideChangedAudit',
    PROJECT_ACTIVITY_TIMING_MILESTONE_OVERRIDE_CHANGED               = 'ProjectActivityProjectTimingMilestoneOverrideChangedAudit',
    PROJECT_ACTIVITY_TIMESPAN_OVERRIDE_CHANGED                       = 'ProjectActivityDefaultTimeSpanOverrideChangedAudit',
    PROJECT_ACTIVITY_NOTE_CHANGED                                    = 'ProjectActivityNotesChangedAudit',

    STATIC_PROJECT_ACTIVITY_STATUS_CHANGED                           = 'StaticProjectActivityCompletionStateChangedAudit',
    STATIC_PROJECT_ACTIVITY_COST_INFO_CHANGED                        = 'StaticProjectActivityCostChangedAudit',
    STATIC_PROJECT_ACTIVITY_OPERATIONAL_COST_CHANGED                 = 'StaticProjectActivityCostChangedAudit',
    STATIC_PROJECT_ACTIVITY_OPERATIONAL_COST_NOTE_CHANGED            = 'StaticProjectActivityCostChangedAudit',
    STATIC_PROJECT_ACTIVITY_ONGOING_COST_CHANGED                     = 'StaticProjectActivityCostChangedAudit',
    STATIC_PROJECT_ACTIVITY_ONGOING_COST_NOTE_CHANGED                = 'StaticProjectActivityCostChangedAudit',
    STATIC_PROJECT_ACTIVITY_START_END_CHANGED                        = 'StaticProjectActivityTimingChangedAudit',
    STATIC_PROJECT_ACTIVITY_DURATION_CHANGED                         = 'StaticProjectActivityDurationChangedAudit',
    STATIC_PROJECT_ACTIVITY_NOTE_CHANGED                             = 'StaticProjectActivityNotesChangedAudit',
}

export enum AUDIT_RECORD_ACTIONS {
    ADD,
    CHANGE,
    REMOVE,
}
